interface StickerValidationResult {
  isValid: boolean;
  errors: string[];
  id?: string;
}

function isStripeValidationError(error: string): boolean {
  const lower = error.toLowerCase();
  return lower.includes('stripe account') || lower.includes('stripe');
}

/** Strip Stripe-related errors from validation — free stickers don't need payment setup. */
export function sanitizeFreeStickerValidation(
  validation: StickerValidationResult,
): StickerValidationResult {
  const nonStripeErrors = (validation.errors || []).filter(
    (err) => !isStripeValidationError(err),
  );

  return {
    ...validation,
    isValid: validation.isValid || nonStripeErrors.length === 0,
    errors: nonStripeErrors,
  };
}
